module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-11-21 at 4.32.06 PM.3b0c6801.jpeg";